import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer style={{ backgroundColor: "#333", color: "#fff", padding: "20px" }}>
      <div style={{ textAlign: "center" }}>
        <p style={{ fontSize: "18px" }}>© Samet Barut</p>
        <p style={{ display: "flex", justifyContent: "center" }}>
          <a
            href="https://github.com/sametbarut"
            style={{
              color: "#fff",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              marginRight: "10px",
            }}
          >
            <FaGithub size={20} style={{ marginRight: "5px" }} />
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/samet-barut"
            style={{
              color: "#fff",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FaLinkedin size={20} style={{ marginRight: "5px" }} />
            LinkedIn
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
